/*
 * @Description: 请求处理
 * @Author: xiawenlong
 * @Date: 2020-12-16 19:57:59
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-15 16:49:56
 */
import axios from 'axios'
import codeMsg from './code-msg'
import router from '@/router'
import { getCookie } from '@/utils/cookies'
class Http {
  constructor() {
    this.baseURL = process.env.VUE_APP_BASE_API
    // this.timeout = 5000
  }
  setInterceptor(instance) {
    instance.interceptors.request.use(
      config => {
        // TODO: 获取token
        const token = getCookie('myToken')
        // const token = 'ironge-user-1f0d1e3633ab4ecd8328fa15e49323b1'
        config.headers.authorization = token
        config.headers.client = 'manage'
        config.headers.terminal = 'Web'
        return config
      },
      error => {
        return Promise.reject(error)
      },
    )
    instance.interceptors.response.use(
      async response => {
        const { data, config } = response
        // blob 下载：若返回 JSON 说明是业务错误，解析后统一处理
        if (config.responseType === 'blob' && data instanceof Blob && /json/i.test(data.type)) {
          try {
            return this.handleCode(JSON.parse(await data.text()))
          } catch (e) {
            return data
          }
        }
        return this.handleCode(data)
      },
      error => {
        const { status = 404 } = error.response
        if (Object.prototype.hasOwnProperty.call(codeMsg, status)) {
          this.errorHandler(error, codeMsg[status])
        }
        throw error
      },
    )
  }
  // 业务码统一处理
  handleCode(data) {
    switch (~~data.code) {
      case 0:
        return data
      case 100104:
      case 100105:
        router.push('/login')
        return data
      default:
        return Promise.reject(data)
    }
  }
  // 异常处理器
  errorHandler(error, msg) {
    if (process.env.NODE_ENV === 'development') {
      console.group('❌ HTTP Error')
      console.log('错误信息：' + msg)
      console.log('接口地址：' + error.response.config.url)
      console.log(error)
      console.groupEnd()
    } else {
      return Promise.reject(error)
    }
  }
  mergeOptions(options) {
    return {
      baseURL: this.baseURL,
      timeout: this.timeout,
      ...options,
    }
  }
  request(options) {
    const instance = axios.create()
    const opts = this.mergeOptions(options)
    this.setInterceptor(instance)
    return instance(opts)
  }
  get(url, config = {}) {
    return this.request({
      method: 'get',
      url,
      ...config,
    })
  }
  post(url, data, config) {
    return this.request({
      method: 'post',
      url,
      data,
      ...config,
    })
  }
}
export default new Http()
